import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ResourcesService {

  constructor(private http: HttpClient) { }

  public secret = "edozcrypt";
  public noteObj = new BehaviorSubject(Object);
  public questionObj = new BehaviorSubject(Object);
  public subResourcesObj = new BehaviorSubject(Object);
  public announcementObj = new BehaviorSubject(Object);

  getResources(data){
    return this.http.post<any>("/edozzier/portal-resources.php", data);
  }

  DownloadVerifyFile(path): any {
    return this.http
        .get(path,
            { responseType: 'blob' });
  }

  // For getting all notes
  getResourcesNote(obj) {
    return this.http.post<any>("/edozzier/portal-resources-note.php", obj);
  }
  // For deleting a particular note
  deleteResourceNote(resource_note_id){
    return this.http.post<any>("/edozzier/portal-delete-resource-note.php", resource_note_id)
  }

  // for sending note details to the backend
  addResourcesNote(obj) {
    return this.http.post<any>("/edozzier/portal-add-resource-note.php", obj)
  }

  // for editing note
  editResourcesNote (obj) {
    return this.http.post<any>("/edozzier/portal-edit-resource-note.php", obj)
  }

  // For getting all questions for a particular course
  getResourcesQuestions(obj) {
    return this.http.post<any>("/edozzier/portal-resources-questions.php", obj);
  }

  getAllResources(obj) {
    return this.http.post<any>("/edozzier/portal-get-all-resources.php", obj)
  }

  addResourcesQuestion(obj) {
    return this.http.post<any>("/edozzier/portal-add-resources-question.php", obj)
  }

  getQuestionResponse(obj){
    return this.http.post<any>("/edozzier/portal-get-question-response.php", obj)
  }

  addQuestionResponse (obj) {
    return this.http.post<any>("/edozzier/portal-add-responses.php", obj);
  }

 getSubResources (obj) {
    return this.http.post<any>("/edozzier/portal-get-sub-resources.php", obj);
  }

  getAnnouncements (obj) {
    return this.http.post<any>("/edozzier/portal-announcements.php", obj);
  }

  getSemesters () {
    return this.http.get<any>("/edozzier/portal-get-semesters.php");
  }




  // getRegisteredCourses(){
  //   return this.http.get<any>("/edozzier/portal-resource-courses.php");
  // }

}
